import { observer } from 'mobx-react-lite'
import React from 'react'
import MediaAction from './MediaAction'

export default observer(function MediaActions({ actions, campaignScenario }) {

  return (
    <div className="p-3 text-xs overflow-x-auto">
      <table className="border border-border-primary dark:border-rb-dark-mode-lighter w-full">
        <thead>
          <tr className="bg-gray-200 dark:bg-rb-dark-mode-lighter">
            <td className="py-3 px-1 text-xs dark:text-white"></td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal dark:text-white">Price</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal dark:text-white">CPM (Follower)</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal dark:text-white">CPM (Impressions)</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[300px] dark:text-white">Impression (based on the current insights)</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[70px] dark:text-white">Buyout</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[120px] dark:text-white">Buyout Price</td>
          </tr>
        </thead>
        <tbody>
          { actions.map(action => <MediaAction key={action.id} action={action} campaignScenario={campaignScenario} />)}
        </tbody>
      </table>
    </div>
  )
})